/**
 * Fungsi untuk memeriksa apakah sebuah nilai adalah hexadecimal
 * @param {string} value - Nilai yang akan diperiksa
 * @returns {boolean} - True jika hexadecimal, False jika tidak
 */

// Validator untuk hanya menerima huruf kecil
export function isLowercase(value) {
  return !/[A-Z]/.test(value); // Returns false only if uppercase letters are found
}

// Validator untuk hanya menerima nilai hexadecimal
export function isHexadecimal(value) {
  return /^[a-f0-9]*$/i.test(value) // Memastikan hanya karakter hexadecimal (a-f, 0-9)
}

export function isAlphaNum(value) {
  return /^[a-zA-Z0-9]+$/.test(value)
}

export function isInteger(value) {
  // Cek apakah nilai adalah integer
  return Number.isInteger(Number(value));
}

export function isIndonesianPhoneNumber(value) {
  // Regex untuk format nomor telepon Indonesia:
  // - Dimulai dengan 0 diikuti 8-12 digit (contoh: 08123456789)
  // - Atau dimulai dengan +62 diikuti 8-12 digit (contoh: +628123456789)
  const regex = /^(?:0|62)8[1-9][0-9]{7,10}$/
  return regex.test(value)
}

export function convertKeysToSnakeCase(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj; // Return non-objects and null as-is
  }

  if (Array.isArray(obj)) {
    return obj.map(item => convertKeysToSnakeCase(item)); // Recursively handle arrays
  }

  const newObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = key.replace(/([A-Z])/g, '_$1').toLowerCase(); // Convert camelCase to snake_case
      newObj[newKey] = convertKeysToSnakeCase(obj[key]); // Recursively handle nested objects
    }
  }
  return newObj;
}